import * as Yup from 'yup';

const PasswordSchema = Yup.object().shape({
  password: Yup.string().min(6, "Password should be minium 6 character").required('Required'),
  cpassword: Yup.string().min(6, "Password should be minium 6 character").required('Required')
});

export default PasswordSchema;
